//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AnnoLayer",1,0],[0,"CSys",1,0],[0,"CenterOfGravity",1,0],[1,"CurveCollector",0,"Section",0],[0,"DatumPlaneLayer",1,0],[0,"DatumPlanes",1,0],[1,"Distance",0,"Expression",0],[1,"FaceCollector",0,"ScCollector",0],[0,"MassPropertyType",1,0],[0,"NSection",1,0],[1,"PathCollector",0,"Section",0],[0,"PrincipalAxes",1,0],[0,"RectangleLayer",1,0],[0,"RectangularSection",1,0],[0,"SecondPrincipleMi",1,0],[0,"SectionArea",1,0],[0,"SectionLayer",1,0],[0,"SectionLength",1,0],[0,"SectionNormal",1,0],[0,"SectioningMethod",1,0],[0,"Sections",1,0],[0,"ShearCenter",1,0],[1,"Thickness",0,"Expression",0],[0,"Type",1,0],[0,"Units",1,1],[0,"ValidityFlag",1,0]],[[[],"ShowInfo",{},0,0],[[],"RefreshScreen",{},0,0],[[],"IsTempGraphics",{R_:{isTempGraphics:''}},0,0],[["n_annotations"],"GetAnnotation",{R_:{annotations:"Annotations.PmiNote[]"}},0,0]],[]];
SPLM.Features.SectionInertiaAnalysisBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SectionInertiaAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SectionInertiaAnalysisBuilder.Types = Object.freeze({
    "ParallelSections" : "ParallelSections", "SectionsAlongCurve" : "SectionsAlongCurve", "ExistingSection" : "ExistingSection"});

SPLM.Features.SectionInertiaAnalysisBuilder.CoordSys = Object.freeze({
    "Absolute" : "Absolute", "CurrentWCS" : "CurrentWCS"});

SPLM.Features.SectionInertiaAnalysisBuilder.SectionAxisNormal = Object.freeze({
    "Xc" : "Xc", "Yc" : "Yc", "Zc" : "Zc"});

SPLM.Features.SectionInertiaAnalysisBuilder.SampleMethod = Object.freeze({
    "ByDistance" : "ByDistance", "ByNumber" : "ByNumber"});

SPLM.Features.SectionInertiaAnalysisBuilder.PropertyType = Object.freeze({
    "Hollow" : "Hollow", "Solid" : "Solid"});

export default SPLM;